import React from 'react';
import { motion } from 'framer-motion';
interface CtaButtonProps {
  text: string;
  className?: string;
}
export function CtaButton({
  text,
  className = ''
}: CtaButtonProps) {
  return <motion.a href="https://claridadmental.shop/cart/53007812624747:1" className={`relative inline-flex items-center justify-center px-8 py-4 text-lg md:text-xl font-bold text-white transition-all duration-300 rounded-full shadow-lg group bg-gradient-to-r from-gold-start to-gold-end hover:shadow-xl hover:scale-[1.02] ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} data-id="element-78">
      <span className="absolute inset-0 w-full h-full rounded-full opacity-50 animate-pulse-slow bg-gradient-to-r from-gold-start to-gold-end blur-md group-hover:opacity-75 transition-opacity" data-id="element-79"></span>
      <span className="relative z-10 text-center uppercase tracking-wide" data-id="element-80">
        {text}
      </span>
    </motion.a>;
}